import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { User } from '../graphql/auth';

export interface UpdateSelfVars {
  data: {
    id: number,
    locale: string
  };
}

interface UpdateSelfData {
  __typename?: string,
  updateSelf: User
}

export const UPDATE_SELF_MUTATION = gql`
    mutation updateSelf($data: UpdateSelfInput!) {
        updateSelf(data: $data) {
            id
            locale
        }
    }
`;

export const updateSelf = () => useMutation<UpdateSelfData, UpdateSelfVars>(
  UPDATE_SELF_MUTATION,
  {}
);

export default updateSelf;